import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth";
import AdminLayout from "./AdminLayout";

export default function RequireAdmin({ children }) {
  const { user, ready } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (ready && !user) nav("/admin/login", { replace: true });
  }, [ready, user, nav]);

  if (!ready || !user) {
    return (
      <div className="ap-loading" data-testid="admin-loading">Loading…</div>
    );
  }
  return <AdminLayout>{children}</AdminLayout>;
}
